module.exports = __webpack_public_path__ + "static/media/sc.91326e3c.svg";